import { useEffect } from 'react';
import { ErrorBoundary } from '../../../../../components/ErrorBoundary';
import { CardCollection } from '../../../../../components/Module/CardCollection';
import { RecordCard } from '../../../../../components/Module/RecordCard';

import { useMapWidgetStore } from '../MapWidgetContext';
import { MapWidgetLegend } from './Legend';

import './style.scss';

interface BottomActionsProps {
  isLegendVisible: boolean;
  isCardVisible: boolean;
}

export const BottomActions = ({
  isLegendVisible,
  isCardVisible,
}: BottomActionsProps) => {
  const {
    recordCardManager,
    map,
    recordCardMouseController,
    browserHistoryCard,
    recordCard,
  } = useMapWidgetStore();

  const isVisible = isCardVisible || isLegendVisible;

  useEffect(() => {
    recordCardMouseController.bind();
    browserHistoryCard.bind();

    return () => {
      recordCardMouseController.unbind();
      browserHistoryCard.unbind();
    };
  }, []);

  if (!isVisible) return <></>;

  return (
    <>
      {isCardVisible && (
        <ErrorBoundary>
          <RecordCard
            recordCard={recordCard}
            recordCardManager={recordCardManager}
            map={map}
            hiddenTabs={['links', 'share']}
            left={40}
            bottom={40}
          />
        </ErrorBoundary>
      )}
      <div className="bottom-actions">
        <div className="bottom-actions__container">
          <div>
            {isCardVisible && (
              <ErrorBoundary>
                <CardCollection
                  recordCardManager={recordCardManager}
                  recordCard={recordCard}
                />
              </ErrorBoundary>
            )}
            {isLegendVisible && (
              <ErrorBoundary>
                <MapWidgetLegend />
              </ErrorBoundary>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
